import Vue from 'vue'

Vue.filter('addBaseFileUrl', value => {
  if (value) {
    return `${value.baseUrl + value.bucketName}/${value.destination}${value.filename}`
  }
  return false
})
